import React, { memo } from 'react';
import Link from 'components/Link';
import s from './BreakingNewsHeadline.scss';
import ElementInView from '../../../../components_v2/common/ElementInView/ElementInView';

const BreakingNewsHeadline = ({ breakingnews }) => {
  if (
    breakingnews &&
    Array.isArray(breakingnews) &&
    breakingnews.length > 0 &&
    breakingnews[0] &&
    breakingnews[0]?.path &&
    breakingnews[0]?.title
  ) {
    return (
      <ElementInView gaAction="Election_Widget_Homepage">
        <h2 className={s.heading}>
          <Link
            to={breakingnews[0].path}
            data-newga={`click-ElectionWidget#${breakingnews[0].path}`}
            target="_blank"
            ga4Data={[
              {
                event: 'user_click',
                type: 'exitpoll_widget',
                label: 'main_widget_title_heading',
              },
            ]}
          >
            {breakingnews[0].title}
          </Link>
        </h2>
      </ElementInView>
    );
  }

  if (
    breakingnews &&
    Array.isArray(breakingnews) &&
    breakingnews.length &&
    breakingnews[0].title
  ) {
    return <h2 className={s.heading}>{breakingnews[0].title}</h2>;
  }
  return null;
};

export default memo(BreakingNewsHeadline);
